<template lang="html">
<div>
  <!-- <v-container class="description-container-background"> -->
  <div class="description-container-background">
    <!-- <div justify-center> -->
    <div class="description-container-center">
      <v-flex xs12 sm10 md9 lg7 xl5>
        <v-container :class="{ descriptionContainer: !mobile }">
          <v-img
            :src="workPhoto"
            max-height="250"
            contain
          >
          </v-img>

          <div class="text-container">
            <h1 class="working-title text-xs-left">Working at Blitzoo</h1>
            <p class="text-xs-left">Blitzoo believes in providing the best tools and work environment for associates, so that they are only limited by their own abilities.</p>
            <p class="text-xs-left">We have an innovative and experienced team who specialize in areas such as game development / design, math modeling, illustration/animation (2D &amp; 3D), music composition, sound effects, voice recording, software engineering, game production and legal (trademark &amp; patent).</p>
          </div>
        </v-container>
      </v-flex>
    </div>
  </div>

  <v-layout>
    <v-flex class="items-container">
      <v-container justify-center class="inner-items-container">
        <v-flex xs12 sm8 md8 lg6 xl5 :class="{ orderItemsContainer: !mobile }">
          <div class="item-container ">
            <v-img
              :src="iconTest"
              max-height="100"
              contain
            >
            </v-img>

            <div class="text-xs-left">
              <h2 class="item-title">Testing facility</h2>
              <p>State-of-art machines to ensure our games are being tested every step of the way to produce the best results</p>
            </div>
          </div>

          <div class="item-container">
            <v-img
              :src="iconCompensation"
              max-height="100"
              contain
            >
            </v-img>

            <div class="text-xs-left">
              <h2 class="item-title">Compensation/Benefits</h2>
              <p>Competitive salaries, bonus incentives and a full range of comprehensive benefits</p>
            </div>
          </div>

          <div class="item-container">
            <v-img
              :src="iconTools"
              max-height="100"
              contain
            >
            </v-img>

            <div class="text-xs-left">
              <h2 class="item-title">The right tools</h2>
              <p>Powerful workstations loaded with premium animation and engineering software</p>
            </div>
          </div>

          <div class="item-container">
            <v-img
              :src="iconTeam"
              max-height="100"
              contain
            >
            </v-img>

            <div class="text-xs-left">
              <h2 class="item-title">Strong team</h2>
              <p>Various team-building events throughout the year to help create community and fun at the office</p>
            </div>
          </div>

          <div class="item-container">
            <v-img
              :src="iconHours"
              max-height="100"
              contain
            >
            </v-img>

            <div class="text-xs-left">
              <h2 class="item-title">Flexible work</h2>
              <p>We are supportive of individual associate needs and will accommodate remote work and  different work hour schedules</p>
            </div>
          </div>

          <div class="item-container">
            <v-img
              :src="iconCulture"
              max-height="100"
              contain
            >
            </v-img>

            <div class="text-xs-left">
              <h2 class="item-title">Company culture</h2>
              <p>A friendly and relaxed environment that fosters personal development and teamwork</p>
            </div>
          </div>

          <div class="item-container">
            <v-img
              :src="iconWellness"
              max-height="100"
              contain
            >
            </v-img>

            <div class="text-xs-left">
              <h2 class="item-title">Associate wellness</h2>
              <p>Ergonomic desks and chairs to support your health and maximize your comfort and productivity</p>
            </div>
          </div>

          <div class="item-container">
            <v-img
              :src="iconSnacks"
              max-height="100"
              contain
            >
            </v-img>

            <div class="text-xs-left">
              <h2 class="item-title">Free snacks &amp; drinks</h2>
              <p>A broad selection of sparkling waters, juices and sodas along with coffee, tea and treats.</p>
            </div>
          </div>
        </v-flex>
      </v-container>
    </v-flex>
  </v-layout>

  <v-container>
    <v-layout>
      <v-flex xs12>
        <v-btn to="/careers" round large color="#5000ff" class="text-capitalize">
          <strong class="contact-button">Open Positions</strong>
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</div>
</template>

<script>
export default {
  computed: {
    mobile () {
      return navigator.userAgent.toLowerCase().indexOf('iphone') > -1 ||
        navigator.userAgent.toLowerCase().indexOf('android') > -1
    }
  },
  data () {
    return {
      workPhoto: require('../assets/careers/WorkingAtKSG/Team_Working.png'),
      iconTest: require('../assets/careers/WorkingAtKSG/Icon_TestingFacility.png'),
      iconCompensation: require('../assets/careers/WorkingAtKSG/Icon_Compensation.png'),
      iconTools: require('../assets/careers/WorkingAtKSG/Icon_RightTools.png'),
      iconTeam: require('../assets/careers/WorkingAtKSG/Icon_StrongTeam.png'),
      iconHours: require('../assets/careers/WorkingAtKSG/Icon_FlexibleHours.png'),
      iconCulture: require('../assets/careers/WorkingAtKSG/Icon_CompanyCulture.png'),
      iconWellness: require('../assets/careers/WorkingAtKSG/Icon_EmployeeWellness.png'),
      iconSnacks: require('../assets/careers/WorkingAtKSG/Icon_FreeSnacks.png')
    }
  },
  methods: {
    carouselLeftClick () {
      if (this.currentCard === 0) {
        this.currentCard = this.employees.length - 1
      } else {
        this.currentCard -= 1
      }
    },
    carouselRightClick () {
      if (this.currentCard === this.employees.length - 1) {
        this.currentCard = 0
      } else {
        this.currentCard += 1
      }
    }
  }
}
</script>

<style lang="css" scoped>
.description-container-background {
  background-image: url('../assets/Background_Yellow.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.description-container-center {
  display: flex;
  justify-content: center;
}

.descriptionContainer {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1rem;
  align-items: center;
}

.working-title {
  font-size: 2.2rem;
  font-family: museo-slab, serif;
  font-style: normal;
  font-weight: 800;
  color: #12013a;
}

.text-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.items-container {
  background-color: #fe00b6;
}

.inner-items-container {
  display: flex;
}

.orderItemsContainer {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-row-gap: 1rem;
  grid-column-gap: 2rem;
}

.item-container {
  display: grid;
  grid-template-columns: 25% 1fr;
  grid-gap: 15px;
  color: #160144;
  font-weight: bold;
}

.item-title {
  font-family: museo-slab, serif;
  font-style: normal;
  font-weight: 800;
  font-size: 1.5rem;
  color: #4807ff;
}

.contact-button {
  font-size: 1.5rem;
  font-family: 'open-sans-extrabold', serif;
  color: #ffffff;
  padding: 0 2rem;
}

.career-title {
  font-family: museo-slab, serif;
  font-weight: 700;
  font-size: 30px;
  color: #f6821f;
  letter-spacing: -2px;
}

.employee-container {
  display: grid;
  grid-template-columns: 40% 1fr;
  grid-gap: 1rem;
}

.employee-quotes {
  display: flex;
  justify-content: space-between;
  /* originally center */
  flex-direction: column;
}

.quote-style {
  line-height: 1.15;
  margin: 0 1rem;
}

.name-color {
  color: #335091;
  margin: 0 1rem;
}

.role-color {
  color: #5677c3 !important;
  font-size: 15px;
}

.carousel-container {
  display: flex;
  align-items: center;
  padding: 0;
}

#carouselLeft:hover, #carouselRight:hover {
  color: rgba(0,0,0,0.3)
}

.lastContainer {
  display: grid;
  grid-template-columns: 60% 40%;
  margin-top: 1rem;
  grid-gap: 2rem;
}

.mobileLastContainer {
  display: grid;
  grid-template-columns: 40% 60%;
  align-items: end;
}

#workTitle {
  font-family: museo-slab, serif;
  font-style: normal;
  font-weight: 800;
  font-size: 4rem;
  color: #335091;
  display: inline-block;
  line-height: 90%;
  margin-bottom: 2rem;
}

#mobileWorkTitle {
  font-family: museo-slab, serif;
  font-style: normal;
  font-weight: 800;
  font-size: 2.9rem;
  color: #335091;
  display: inline-block;
  line-height: 100%;
  margin-bottom: 1rem;
}

.carouselDirection {
  z-index: 10;
  position: absolute;
  margin-left: -1rem;
  /* top: 50%; */
  margin-top: 5rem;
  left: 0;
  opacity: 0.4;
}

.carouselDirection:hover {
  opacity: 1;
}

.carouselDirectionRight {
  z-index: 10;
  position: absolute;
  margin-right: -1rem;
  /* top: 50%; */
  margin-top: 5rem;
  right: 0;
  opacity: 0.4;
}

.carouselDirectionRight:hover {
  opacity: 1;
}

.mobileLearnMore {
  margin: 0;
}
</style>
